import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MarkRequestReadState, ReadState, RequestReadState } from '@atlassian/notification-common/types';
import markNotificationGroupFetch from '../../../../utils/mark-group-client';
export var markGroup = function markGroup(groupId, toState, readStateFilter, handlers) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var getState, setState, groups, groupIndex, headNotification;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getState = _ref.getState, setState = _ref.setState;
            groups = getState().groups;
            groupIndex = groups.findIndex(function (group) {
              return group.id === groupId;
            });
            if (!(groupIndex === -1)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            headNotification = groups[groupIndex].notifications[0];
            if (headNotification) {
              markNotificationGroupFetch(groupId, headNotification.id, toState === ReadState.READ ? MarkRequestReadState.READ : MarkRequestReadState.UNREAD).then(function (_) {
                return handlers.onSuccess('/notification-groups/mark');
              }).catch(function (e) {
                return handlers.onError(e.code);
              });
            }
            setState({
              groups: groups.reduce(function (newGroups, currentGroup, index) {
                if (index !== groupIndex) {
                  newGroups.push(currentGroup);
                  return newGroups;
                }

                // Group should be removed from view if we are filtering by unread notifications
                // and the new readState is READ
                if (readStateFilter === RequestReadState.UNREAD && toState === ReadState.READ) {
                  return newGroups;
                }
                newGroups.push(_objectSpread(_objectSpread({}, currentGroup), {}, {
                  readStates: [toState],
                  // Marking all in group will result in a single read state for the group
                  notifications: currentGroup.notifications.map(function (notification) {
                    return _objectSpread(_objectSpread({}, notification), {}, {
                      readState: toState
                    });
                  })
                }));
                return newGroups;
              }, [])
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};